/**
 * Opções das perguntas do chat de triagem. As chaves batem com o que vai para o banco
 * (estado da conversa e colunas do lead); os rótulos são o que a pessoa vê nos balões.
 */

export const OBJETIVOS = ['instalar', 'manutencao'] as const;
export type Objetivo = (typeof OBJETIVOS)[number];
export const OBJETIVO_LABEL: Record<Objetivo, string> = {
  instalar: 'Quero instalar energia solar',
  manutencao: 'Já tenho sistema e preciso de manutenção',
};

export const IMOVEIS = ['casa', 'empresa', 'industria', 'rural', 'condominio', 'apartamento'] as const;
export type Imovel = (typeof IMOVEIS)[number];
export const IMOVEL_LABEL: Record<Imovel, string> = {
  casa: 'Casa',
  empresa: 'Comércio ou escritório',
  industria: 'Indústria',
  rural: 'Propriedade rural',
  condominio: 'Condomínio',
  apartamento: 'Apartamento',
};

/** Faixas da conta de luz. `reais` é o valor gravado quando a pessoa escolhe a faixa em vez de digitar. */
export const FAIXAS_CONTA = [
  { valor: 'ate_300', rotulo: 'Até R$ 300', reais: 250 },
  { valor: '300_800', rotulo: 'R$ 300 a R$ 800', reais: 550 },
  { valor: '800_2000', rotulo: 'R$ 800 a R$ 2.000', reais: 1400 },
  { valor: 'acima_2000', rotulo: 'Acima de R$ 2.000', reais: null },
] as const;

/** Valor gravado quando a conta é acima de R$ 2.000 e a pessoa prefere não dizer quanto. */
export const CONTA_ACIMA_PADRAO = 2000;

export const PROPRIEDADES = ['proprio', 'alugado', 'construindo'] as const;
export type Propriedade = (typeof PROPRIEDADES)[number];
export const PROPRIEDADE_LABEL: Record<Propriedade, string> = {
  proprio: 'Sim, é meu',
  alugado: 'É alugado',
  construindo: 'Estou construindo ou comprando',
};

export const LOCAIS = ['ceramico', 'metalico', 'laje', 'solo', 'nao_sei'] as const;
export type Local = (typeof LOCAIS)[number];
export const LOCAL_LABEL: Record<Local, string> = {
  ceramico: 'Telhado de telha',
  metalico: 'Telhado metálico ou fibrocimento',
  laje: 'Laje',
  solo: 'No chão, em área livre',
  nao_sei: 'Ainda não sei',
};

export const PAGAMENTOS = ['a_vista', 'financiado', 'nao_sei'] as const;
export type Pagamento = (typeof PAGAMENTOS)[number];
export const PAGAMENTO_LABEL: Record<Pagamento, string> = {
  a_vista: 'À vista',
  financiado: 'Financiado',
  nao_sei: 'Ainda não sei',
};

export const PRAZOS = ['30_dias', '1_3_meses', 'pesquisando'] as const;
export type Prazo = (typeof PRAZOS)[number];
export const PRAZO_LABEL: Record<Prazo, string> = {
  '30_dias': 'Nos próximos 30 dias',
  '1_3_meses': 'Em 1 a 3 meses',
  pesquisando: 'Só pesquisando por enquanto',
};
